
import * as React from "react";
import {type RouteObject} from "react-router-dom";
import { LiveShuttleScreen } from "./ui/screens/live-shuttles-screen";


export function getLiveShuttlesRoutesDefinitions(): RouteObject[] {
	return [
		{
			index: true,
			element: <LiveShuttleScreen/>,
		},
	] satisfies RouteObject[];
}
